<template>
  <div>
    <div class="main">
      <div class="header" v-if="flag">
        <ul>
          <li>
            <a
              href="javascript:;"
              @click="category(1)"
              :class="{ choose: isChoose == 1 }"
            >
              未提出 (
              <strong>{{ tabData.orderTemporary }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(0)"
              :class="{ choose: isChoose == 0 }"
            >
              配送依頼書 (
              <strong>{{ tabData.all }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(2)"
              :class="{ choose: isChoose == 2 }"
            >
              見積中 (
              <strong>{{ tabData.orderConfirm }}</strong>
              )
            </a>
            <span>|</span>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="category(3)"
              :class="{ choose: isChoose == 3 }"
            >
              送料支払い待ち (
              <strong>{{ tabData.orderPay }}</strong>
              )
            </a>
            <span>|</span>
          </li>

          <li>
            <a
              href="javascript:;"
              @click="category(4)"
              :class="{ choose: isChoose == 4 }"
            >
              配送中 (
              <strong>{{ tabData.orderDelivery }}</strong>
              )
            </a>
            <span>|</span>
          </li>
        </ul>
        <a href="javascript:;" class="fr history" @click="historyOrder"
          >過去の注文書</a
        >
      </div>
      <div class="header" v-else>
        <a href="javascript:;" class="history fl">過去の注文書</a>
        <div class="search fl">
          <input type="text" v-model="list.pordno" placeholder="注文書番号" />
          <a href="javascript:;" @click="getOrderList">確定</a>
        </div>
        <span class="fanghui fr" @click="backtrack">戻る</span>
      </div>
      <div id="search" v-if="flag">
        <div class="date fl">
          日付
          <el-date-picker
            v-model="list.dateStart"
            type="date"
            placeholder="日付を選択"
            size="mini"
            value-format="yyyy-MM-dd"
          ></el-date-picker
          >--
          <el-date-picker
            v-model="list.dateEnd"
            type="date"
            placeholder="日付を選択"
            size="mini"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <a href="javascript:;" @click="getOrderList">確定</a>
        </div>
        <div class="search fr">
          <input
            type="text"
            v-model="list.pordno"
            placeholder="配送依頼書番号"
          />
          <a href="javascript:;" @click="getOrderList">確定</a>
        </div>
      </div>
      <div class="content">
        <!-- 头部 -->
        <ol v-if="flag">
          <li class="w40">NO</li>
          <li class="w278" style="text-align: center;">配送依頼書番号</li>
          <li class="w103">提出日</li>
          <li class="w103">重量</li>
          <li class="w103">国際送料</li>
          <li class="w145">状態</li>
          <li class="w110">エクセル導出</li>
          <li class="w65">操作</li>
        </ol>
        <ol v-else>
          <li class="w40">NO</li>
          <li class="w278">配送依頼書番号</li>
          <li class="w103">提出日</li>
          <li class="w110">エクセル導出</li>
          <li class="w145">状態</li>
        </ol>
        <!-- 订单内容 -->
        <div v-if="flag">
          <ul v-for="(item, index) in orderList.list" :key="index">
            <li class="w40">{{ index + 1 }}</li>
            <li class="w278">
              <router-link
                target="_blank"
                :to="{ name: 'deliver', query: { pordno: item.pordno } }"
                >{{ item.pordno }}-{{ item.receiveRealname }}</router-link
              >
            </li>
            <li class="w103">{{ item.datetime }}</li>

            <li class="w103">{{ item.freight }}</li>
            <li>{{ item.kin }}</li>
            <li class="w145">{{ item.statusName }}</li>
            <li class="w110">
              <i class="el-icon-download" @click="downloadOrder(item)"></i>
            </li>
            <li class="w65">
              <router-link
                target="_blank"
                :to="{ name: 'deliver', query: { pordno: item.pordno } }"
                v-if="item.kno == 4"
                >支払い</router-link
              >
              <a
                href="javascript:;"
                v-if="item.kno == 0"
                @click="delOrder(item)"
                >削除</a
              >
            </li>
          </ul>
        </div>
        <div v-else>
          <ul v-for="(item, index) in orderList.list" :key="index">
            <li class="w40">{{ index + 1 }}</li>
            <li class="w278">
              <router-link
                :to="{ name: 'zhuwen', query: { ordno: item.pordno } }"
                target="_blank"
                >{{ item.pordno }}-{{ item.receiveRealname }}</router-link
              >
            </li>
            <li class="w103">{{ item.datetime }}</li>
            <li class="w110">
              <i class="el-icon-download" @click="downloadOrder(item)"></i>
            </li>
            <li class="w145">{{ item.statusName }}</li>
          </ul>
        </div>
        <div class="fenye">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="list.page"
            :page-size="20"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 删除弹框 -->
    <el-dialog :visible.sync="dellogVisible" width="35%">
      <h3>
        <img src="../../../assets/img/tip.png" alt />
        選択中の注文書削除してもよろしいでしょうか？
      </h3>
      <div class="body">
        <p class="fl" style="line-height: 30px; margin: 0 20px">
          理由をご記入ください：
        </p>
        <el-select
          v-model="value"
          placeholder="请选择"
          size="mini"
          @change="reason"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div class="txt">
          <textarea
            name="reworkmes"
            cols="53"
            rows="8"
            placeholder="詳細"
            v-model="txt"
            v-show="show"
          ></textarea>
        </div>
        <div class="btn">
          <a
            href="javascript:;"
            style="color: #fff; background: #f3c622"
            @click="delOrdno"
            >確定</a
          >
          <a href="javascript:;" @click="dellogVisible = false">キャンセル</a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getOrderList, delOrder } from "../../../api/API/order";
export default {
  data() {
    return {
      flag: true,
      token: localStorage.getItem("token"),
      isChoose: 0, // 添加类名
      tabData: {}, // 状态条数
      orderList: [], // 列表数据
      // 请求参数
      list: {
        mod: "inc",
        act: "ordersys",
        str: "getPOrderList1",
        token: "",
        page: 1,
        pageSize: 20,
        state: 0,
        pordno: "",
        dateStart: "",
        dateEnd: "",
      },
      dellogVisible: false, // 删除弹框
      //  删除参数
      delList: {
        mod: "inc",
        act: "orderapi",
        str: "delDistribution",
        token: "",
        pordno: "",
        reason: "",
      },
      // 删除理由option
      options: [
        {
          value: "送料が高い",
          label: "送料が高い",
        },
        {
          value: "追加依頼する",
          label: "追加依頼する",
        },

        {
          value: "その他",
          label: "その他",
        },
      ],
      value: "送料が高い",
      txt: "",
      show: false,
      total: 0,
    };
  },
  created() {
    if (this.$route.query.state) {
      this.list.state = this.$route.query.state;
      this.isChoose = this.$route.query.state;
    }
    this.getOrderList();
  },
  methods: {
    // 各种状态筛选
    category(index) {
      this.isChoose = index;
      this.list.state = index;
      this.getOrderList();
    },
    // 获取数据
    getOrderList() {
      this.list.token = this.token;
      console.log(this.list);
      getOrderList(this.list).then((res) => {
        this.orderList = res.data;
        if (res.code != 1) return;
        this.tabData = res.data.tabData;
        this.total = res.data.total - 0;
        console.log(res.data);
      });
    },
    // 历史订单
    historyOrder() {
      this.list.state = 5;
      this.flag = false;
      this.getOrderList();
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.list.page = val;
      this.getOrderList();
    },
    // 返回订单列表
    backtrack() {
      this.flag = true;
      this.list.state = 0;
      this.isChoose = 0;
      this.getOrderList();
    },
    // 删除订单
    delOrder(item) {
      console.log(item);
      this.value = "";
      this.txt = "";
      this.delList.token = this.token;
      this.delList.pordno = item.pordno;
      this.dellogVisible = true;
    },
    // 选择删除理由
    reason() {
      if (this.value == "その他") {
        this.delList.reason = this.txt;
        this.show = true;
      } else {
        this.show = false;
        this.delList.reason = this.value;
      }
    },
    // 确认删除订单
    delOrdno() {
      if (this.value == "その他") {
        if (this.txt == "") {
          return this.$message.warning("请选择删除理由");
        } else {
          this.delList.reason = this.txt;
        }
      }
      console.log(this.delList);
      delOrder(this.delList).then((res) => {
        console.log(res);
        this.dellogVisible = false;
        if (res.code != 1) return this.$message.error("订单削除失败");
        this.$message.success("削除完了");
        this.getOrderList();
      });
    },
    // excel 下载
    downloadOrder(item) {
      var aLink = document.createElement("a");
      aLink.href =
        "https://www.rakumart-2c.com/index.php?mod=inc&act=user_pexcel&pordno=" +
        item.pordno;
      //   console.log(aLink.href);
      aLink.click();
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 50px;
  .header {
    background-color: #e4e5ea;
    height: 44px;
    line-height: 40px;
    ul {
      float: left;
      li {
        // &:hover a {
        //   color: #666;
        // }
        height: 40px;
        float: left;
        margin: 0 10px;
        color: #333;
        a {
          display: inline-block;
          height: 40px;
          color: #333;
          strong {
            color: #f3c622;
          }
        }
        .choose {
          color: #f3c622;
          border-bottom: 2px solid #f3c622;
        }
        span {
          margin-left: 10px;
        }
      }
    }
    .history {
      margin-right: 20px;
      margin-left: 20px;
      color: #333;
      text-decoration: underline;
      &:hover {
        color: #666;
      }
    }
    .search {
      margin: 0 10px 0 0;
      input {
        padding-left: 5px;
        border: 1px solid #ccc;
        width: 150px;
        height: 26px;
        border-radius: 5px;
      }
      a {
        margin-left: 5px;
        font-size: 14px;
        color: #fff;
        display: inline-block;
        width: 50px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        border-radius: 5px;
        background-color: #f3c622;
      }
    }
    .fanghui {
      margin-right: 30px;
      cursor: pointer;
    }
  }
  #search {
    height: 44px;
    border: 1px solid #ccc;
    .date {
      margin: 7px 0 0 10px;
    }
    .search {
      margin: 7px 10px 0 0;
      input {
        padding-left: 5px;
        border: 1px solid #ccc;
        width: 150px;
        height: 26px;
        border-radius: 5px;
      }
    }
    a {
      margin-left: 5px;
      font-size: 14px;
      color: #fff;
      display: inline-block;
      width: 50px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border-radius: 5px;
      background-color: #f3c622;
    }
  }
  .content {
    border: 1px solid #ccc;
    margin-top: 0;
    padding-bottom: 50px;
    ol {
      border-bottom: 1px solid #ccc;
      height: 37px;
      display: flex;
    }
    ul {
      border-bottom: 1px solid #ccc;
      height: 37px;
      display: flex;
      &:hover {
        background: #eee;
      }
    }
    li {
      float: left;
      flex: 1;
      line-height: 37px;
      font-weight: 500;
      text-align: center;
      overflow: hidden;
      img {
        margin-left: 10px;
        cursor: pointer;
      }
      a {
        color: #333;
        &:hover {
          text-decoration: underline;
        }
      }
      .el-icon-download {
        font-size: 25px;
        &:hover {
          color: #f3c622;
          cursor: pointer;
        }
      }
    }
    .w278 {
      flex: 2.8;
      text-align: left;
    }
  }
}
h3 {
  height: 26px;
  background: #eee;
  line-height: 26px;
  img {
    margin: 0 10px 0 20px;
    vertical-align: middle;
  }
}
.body {
  margin-top: 50px;
  height: 200px;
  text-align: center;
  .txt {
    margin: 10px 0 20px 20px;
    height: 100px;
  }
  .btn {
    margin-right: 30px;
    a {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      float: right;
      margin-left: 20px;
      color: #333;
      border-radius: 5px;
    }
  }
}
.fenye {
  width: 500px;
  margin: 30px auto;
  text-align: center;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #f3c622;
}
</style>